import { Dialog, DialogContent } from "@/components/ui/dialog";
import { DraftEditor } from "@/components/DraftEditor";
import { ScrollArea } from "@/components/ui/scroll-area";
import { convertStoredToDisplayFormat } from "../lib/contentFormatting";

interface EditContentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialContent: string;
  contentType: "draft" | "scheduled";
  itemId: string;
  onContentUpdated: () => void;
  scheduledFor?: string;
  images?: string[];
  video?: string | null;
}

export const EditContentDialog = ({
  open,
  onOpenChange,
  initialContent,
  contentType,
  itemId,
  onContentUpdated,
  scheduledFor,
  images = [],
  video = null,
}: EditContentDialogProps) => {
  // Convert the stored format to display format when showing the content
  const displayContent = convertStoredToDisplayFormat(initialContent);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh]">
        <ScrollArea className="h-[calc(90vh-4rem)]">
          <div className="p-6">
            <DraftEditor
              initialContent={displayContent}
              draftId={itemId}
              onSaveDraft={onContentUpdated}
              onSchedule={onContentUpdated}
              contentType={contentType}
              scheduledFor={scheduledFor}
              isDialog
              initialImages={images}
              initialVideos={video ? [video] : []}
            />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};